<template>
  <div>Loading...</div>
</template>

<script>
import Vue from 'vue';
import axios from "axios";

export default  Vue.extend({
  name: "callback",
  data: () => ({
    response: null
  }),
  mounted ()  {      
      const body = new URLSearchParams()
      body.append('client_id',this.$store.state.app_id)
      body.append('scope', this.$store.state.scope)
      body.append('code', this.$route.query.code)
      body.append('redirect_uri', this.$store.state.callback_url)
      body.append('grant_type', 'authorization_code')
      body.append('code_verifier', sessionStorage.getItem('code_verifier'))
      axios
      .post(this.$store.state.token_url,
      body,
      {headers: {'Content-Type':'application/x-www-form-urlencoded'}}
      )
      .then((response)=>{
        sessionStorage.setItem('access_token',response.data.access_token);
        axios
        .get(this.$store.state.api_url+`/session`,{headers: { Authorization: `Bearer ${sessionStorage.getItem('access_token')}`}})
        .then((session)=>{
          sessionStorage.setItem('user_info',JSON.stringify(session.data.user))
          this.$router.push("/deviceList")
        })
        .catch((error)=>{
          if (error.response) {        
              this.$router.push(`/Error?errorCode=${error.response.status}&errorText=${error.response.statusText}&errorMsg=${error.response.data.Message}`)            
          } else if (error.request) {            
              this.$router.push(`/Error`)
          } else {            
              this.$router.push(`/Error`)
          }
          })
      })
      .catch(()=>{
        this.$router.push("/Error")
      })
  }
});
</script>
